import styles from './appBrand.module.css';

const AppBrand = () => (
  <span className={styles.brand} role="img" aria-label="CRASHPRO — 1800MYAUTOS.COM">
    <span className={styles.name} aria-hidden="true">CRASHPRO</span>
    <img className={styles.logo} src="/static/logo.svg" width="1920" height="414" alt="" aria-hidden="true" />
  </span>
);

export default AppBrand;
